import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Homepage.css";
import Footer from "../../assets/Footer/Footer";
import logovandark from "../../assets/Images/1Logovandark.png";

// TEMP hero image reference (change later)
// import heroImage from "../../assets/Images/fontyslogo/1.png";
import heroImage from "../../assets/Images/1.jpeg";


function Homepage() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div className="homepage">
      {/* ================= HEADER ================= */}
      <header className="homepage-header">
        <div className="logo-box" onClick={() => navigate("/")}>
          <img src={logovandark} alt="logo" className="logo-image" />
        </div>

        <div className="hero-section">
          <img
            src={heroImage}
            alt="Hero visual"
            className="hero-image"
          />
        </div>
      </header>

      {/* ================= MAIN ================= */}
      <main className="homepage-main">
        <div className="lorem-text">
          <h1>Welcome to my Portfolio</h1>
          <p>
            This portfolio showcases all the work I have completed throughout my
            studying journey.
          </p>
        </div>

        <div className="projects-container">
          {/* School Projects */}
          <div
            className="project-box-large school-projects-bg"
            onClick={() => navigate("/school-projects")}
          >
            <div className="project-placeholder-large">
              <span className="project-title-inside">School Projects</span>
            </div>
          </div>

          {/* Personal Projects */}
          <div
            className="project-box-large personal-projects-bg"
            onClick={() => navigate("/personal-projects")}
          >
            <div className="project-placeholder-large">
              <span className="project-title-inside">Personal Projects</span>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Homepage;
